import React, { lazy, Suspense } from "react";
import PageLoading from "../components/DesignSystem/PageLoading.jsx";
import { Container } from "../components/DesignSystem/SelfTissus/ContainersST.jsx";
import RechercheResultats from "../components/Recherche/Recherche.jsx";


const Footer1ST = lazy(() => import("../components/FooterST/Footer1_ST.jsx"));
const Footer2ST = lazy(() => import("../components/FooterST/Footer2_ST.jsx"));
const Footer3ST = lazy(() => import("../components/FooterST/Footer3_ST.jsx"));
const Footer4ST = lazy(() => import("../components/FooterST/Footer4_ST.jsx"));

export default function RechercheST() {
  return (
  
    <Suspense fallback={<PageLoading/>}>
    <Container>
      <RechercheResultats />
    </Container>
    <Footer1ST />
    <Footer2ST />
    <Footer3ST />
    <Footer4ST />
    </Suspense>
    
  );
}

